import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/store/modules/api.js'
import nodered from '@/store/modules/nodered.js'
import timer from '@/store/modules/timer.js'
import mensajes from '@/store/modules/mensajes.js'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tiempo_horno_en_marcha:0,
    tiempo_horno_pausado:0,
    datosAntiguosCargados:false,
    //tiempoEnMarcha:0,
    inicio_ciclo:null,
    estado_horno:1,
    recetaCargada:{},
    trabajoCargado:{},
    recetas:[],
    users:[],
    tipos_de_tratamiento:[],
    tiempo_real_zona_2:null,
    tiempo_real_zona_1:null,
    tiempo_real_zona_agua:null,
    datos_pv_1:[],
    datos_pv_2:[],
    datos_pv_1_contacto: [],
    datos_pv_2_contacto: [],
    datos_agua:[],
    datos_setpoint:[],
    is_admin:false,
    detalles_tratamiento_actual:[],
    historico_trabajos:[],
    datos_popup:{},
    alarmas_activas:[],
    alarmas:[],
    alarmas_quemadores:[],
    quemadores:[],
    historico_alarmas:[],
    inicio_programado:null,
  },
  getters: {
    getIsAdmin(state){
      return state.is_admin
    }
  },
  mutations: {
    SET_TIPOS_TRATAMIENTO(state,payload){
      state.tipos_de_tratamiento=payload;
    },
    SET_USUARIOS(state,payload){
      state.users=payload;
    },
    SET_HISTORICOS(state,payload){
      state.historico_trabajos=payload;
    },
    SET_HISTORICOS_ALARMAS(state,payload){
      state.historico_alarmas=payload;
    },
    // SET_TIEMPO_EN_MARCHA(state,payload){
    //   state.tiempoEnMarcha=payload;
    // },
    SET_ALARMAS(state,payload){
      state.alarmas=payload;
      console.log(state.alarmas)
      let quemadores = state.alarmas.filter(e => e.descripcion.includes('quemador'))
      if(quemadores.length > 0)
        state.alarmas_quemadores = quemadores.map(e => {
          let partes = e.descripcion.split(' ')
          e.quemador = parseInt(partes[partes.length - 1])
          if(e.descripcion.includes('zona'))
            e.quemador = e.quemador + 10
          return e})
    }
  },
  actions: {
    setDatosPopup({state},datos){
      let quemadores = datos.filter(e => e.name.includes('QUEMADOR'))
      if(quemadores.length > 0)
        state.quemadores = quemadores.map(e => { 
          let partes = e.name.split('_')
          e.id  = parseInt(partes[partes.length - 1])
          if(e.name.includes('ZONA'))
            e.id = e.id + 10
          return e})
      if(state.alarmas_activas.length > 0 && state.alarmas_quemadores.length > 0){
        state.alarmas_activas.forEach(element => {
          let alarma = state.alarmas_quemadores.find(a =>a.id == element.id)
          if(alarma){
            let quemador = state.quemadores.find(e => e.id == alarma.quemador)
            if(quemador){
              quemador.value = 2
            }
          }
        });

      }
      state.datos_popup = datos
    },
    setAlarmasActivas({state},datos){
      state.alarmas_activas = datos
      if(state.quemadores.length > 0 && state.alarmas_quemadores.length > 0){
        state.alarmas_activas.forEach(element => {
          let alarma = state.alarmas_quemadores.find(a =>a.id == element.id)
          if(alarma){
            let quemador = state.quemadores.find(e => e.id == alarma.quemador)
            if(quemador)
              quemador.value = 2
          }
        });
        
      }
    },
    async cargaInicial ({ state,dispatch,commit }) {
      try{
        // const currentDate = new Date();

        // const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        // let year = firstDayOfMonth.getFullYear();
        // let month = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0');
        // let day = String(firstDayOfMonth.getDate()).padStart(2, '0');
        // let fecha_inicio= `${year}-${month}-${day}`;

        // const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        // year = lastDayOfMonth.getFullYear();
        // month = String(lastDayOfMonth.getMonth() + 1).padStart(2, '0');
        // day = String(lastDayOfMonth.getDate()).padStart(2, '0');
        // let fecha_fin = `${year}-${month}-${day}`;
      
        const tipostratamientos_raw = await dispatch('api/getTiposTratamiento');
        const alarmas_raw = await dispatch('api/getAlarmas');
        dispatch('recargarRecetas')
        //Guardamos los datos en el Store
          const usuarios_raw  =  await dispatch('api/getUsers')
          commit('SET_USUARIOS',usuarios_raw.data);
        commit('SET_TIPOS_TRATAMIENTO',tipostratamientos_raw.data);
        commit('SET_ALARMAS',alarmas_raw.data);
      }catch(e){
        console.log(e);
      }
    },
    setHistoricos({state, commit}, historicos){
      commit('SET_HISTORICOS',historicos);
    },
    setHistoricosAlarmas({state, commit}, historicos){
      commit('SET_HISTORICOS_ALARMAS',historicos);
    },
    setIsAdmin({state}, value){
      state.is_admin = value
    },
    setRol({state}, value){
      console.log('Entro en setROl');
      switch (value) {
        case 1:
          state.rol = 'admin'
          break;
        case 2:
          state.rol = 'avanzado'
          break;
        case 3:

          state.rol = 'normal'
          break;
        default:
          state.rol = 'normal'
          break;
      }
    },
    async recargarRecetas({commit, state}){
      const response = await this.dispatch('api/getRecetas')
      state.recetas = response.data;
      state.recetas.splice();
      console.log("recetas recargadas!");
    },
    
    setInicioCiclo({commit,dispatch, state},inicio){
      state.inicio_ciclo = inicio
      if(inicio != null && inicio != undefined){
        state.inicio_programado = null
      }
      //state.estado_horno = 2
    },
    setEnMarchaCiclo({commit,dispatch, state},inicio){
      let user = JSON.parse(localStorage.getItem("user"))
      if(user.username != "produccion"){//si es un usuario externo a la nave
        dispatch('nodered/doPublish',{topic:process.env.VUE_APP_TOPIC_SENAL_HORNO,payload:JSON.stringify({id_usuario: user.id, estado:2})})
      }
      dispatch('nodered/doPublish',{topic:process.env.VUE_APP_TOPIC_PROGRAMAR_INICIO,payload:JSON.stringify({timestamp_inicio: inicio, id_usuario: user.id, estado:2})})
      // dispatch('setInicioCiclo', new Date(inicio))
      state.inicio_programado = new Date(inicio)
    },
    cambioEstadoDesdeNodered({state},estado){
      state.estado_horno = parseInt(estado)
    },
    setPausaCiclo({dispatch,state},fecha){
      let user = JSON.parse(localStorage.getItem("user"))
      dispatch('nodered/doPublish',{topic:process.env.VUE_APP_TOPIC_ESTADOS,payload:JSON.stringify({id_usuario: user.id, estado:3})})
      //state.estado_horno = 3
    }, 
    setReanudarCiclo({dispatch,state},fecha){
      let user = JSON.parse(localStorage.getItem("user"))
      dispatch('nodered/doPublish',{topic:process.env.VUE_APP_TOPIC_ESTADOS,payload:JSON.stringify({id_usuario: user.id, estado:4})})
    },
    setPararCiclo({dispatch,state},fecha){
      let user = JSON.parse(localStorage.getItem("user"))
      dispatch('nodered/doPublish',{topic:process.env.VUE_APP_TOPIC_ESTADOS,payload:JSON.stringify({id_usuario: user.id, estado:1})})

      // state.tiempoEnMarcha = 0
      //state.estado_horno = 1
      state.inicio_ciclo = null
      state.trabajoCargado = {}
    },
    // acSetTiempoMarcha({commit},payload){
    //   commit('SET_TIEMPO_EN_MARCHA',payload)
    // },
    async cargarReceta({commit, dispatch,state},receta){
      try {
        const trabajo_raw = await dispatch('api/postTrabajo',receta.raw);
        const objeto={
          tramos:receta.payload,
          delta_time:1,
          setpoint_inicial:receta.first_setpoint,
          id_trabajo:trabajo_raw.data.id_trabajo
        }
        state.detalles_tratamiento_actual=receta.payload

        await dispatch('nodered/loadReceta',objeto)

        const trabajo_cargado_raw = await dispatch('api/getTrabajo',trabajo_raw.data.id_trabajo);


        state.trabajoCargado = trabajo_cargado_raw.data
        state.trabajoCargado.nombre_tipo_tratamiento = receta.raw.nombre_tipo_tratamiento
       

      } catch (error) {
        console.error(error)
      }


    },
    quitarRecetaCargada({commit, state}){
      this.dispatch('setPararCiclo')
    },




    ///////////////////// trabajo //////////////////////
    setTrabajo({state},trabajo){
      state.trabajoCargado=trabajo;
    },
    setEstadoTrabajo({state},estado){
      state.estado_horno=estado
      if(estado==5){
        
      }
    },
    setTiempoHornoEnMarcha({state},t){
      state.tiempo_horno_en_marcha=t
    },
    setTiempoHornoEnPausa({state},t){
      state.tiempo_horno_pausado=t
    },

    setTiempoRealZ1({state}, temperatura){
      state.tiempo_real_zona_1 = temperatura
    },
    setTiempoRealZ2({state}, temperatura){
      state.tiempo_real_zona_2 = temperatura
    },
    setTiempoRealZAgua({state}, temperatura){
      state.tiempo_real_zona_agua = temperatura
    },



    ////// Obtener detalles del tratamiento actual al cargar la web /////////
    // getTratamientoActual({dispatch}){
    //   dispatch('nodered/doPublish',{topic:'TRAER_CICLO_1'})
    // },
    
    setTratamientoActual({state},detalles_tratamiento_actual){
    },
    pushDatosP1({commit, state},dato){
     // console.log('pushDatosP1',dato)
      const existeElemento = this.state.datos_pv_1.find(
        (elemento) => elemento.x === dato.x
      );
      if(!existeElemento)state.datos_pv_1.push(dato)
      else existeElemento.y=dato.y
    },
    pushDatosP2({commit, state},dato){
      const existeElemento = this.state.datos_pv_2.find(
        (elemento) => elemento.x === dato.x
      );
      if(!existeElemento)state.datos_pv_2.push(dato)

      
    },
    pushDatosP1Contacto({commit, state},dato){
      const existeElemento = this.state.datos_pv_1_contacto.find(
        (elemento) => elemento.x === dato.x
      );
      if(!existeElemento){
        if(dato.y < 1300) state.datos_pv_1_contacto.push(dato) //Quitamos de forma visual fallo de comunicación
      }
      else existeElemento.y=dato.y
    },
    pushDatosP2Contacto({commit, state},dato){
      const existeElemento = this.state.datos_pv_2_contacto.find(
        (elemento) => elemento.x === dato.x
      );
      if(!existeElemento){
        if(dato.y < 1300) state.datos_pv_2_contacto.push(dato) //Quitamos de forma visual fallo de comunicación
      }
      else existeElemento.y=dato.y
    },
    pushDatosAgua({commit, state},dato){
      const existeElemento = this.state.datos_agua.find(
        (elemento) => elemento.x === dato.x
      );
      if(!existeElemento)state.datos_agua.push(dato)
     
    },
    pushDatosSetpoint({state},dato){
      const existeElemento = this.state.datos_setpoint.find(
        (elemento) => elemento.x === dato.x
      );
      if(!existeElemento)state.datos_setpoint.push(dato)
    },

    setPVZona1({commit,state},datos){
      state.datos_pv_1 = datos
    },
    setPVZona2({commit,state},datos){
      state.datos_pv_2 = datos
    },
    setPVZonaAgua({commit,state},datos){
      state.datos_agua = datos
    },setSetpoints({state},datos){
      state.datos_setpoint = datos
    },setDatosAntiguosCargados({state},payload){
      state.datosAntiguosCargados=payload
    },
    setInicioProgramado({state},payload){
      state.inicio_programado = payload
    }
  },
  modules: {
    api, nodered, timer, mensajes
  }
})
